import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, Star } from "lucide-react";

interface ProcessInfoProps {
  className?: string;
  isMobile?: boolean;
}

export function ProcessInfo({ className = "", isMobile = false }: ProcessInfoProps) {
  if (isMobile) {
    return (
      <Card className={`border border-gray-200 bg-white ${className}`}>
        <CardContent className="p-3 sm:p-4">
          <h3 className="text-fluid-base font-semibold text-slate-900 space-grotesk mb-4">How It Works</h3>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-orange-600 font-bold text-fluid-sm">1</span>
              </div>
              <div>
                <h4 className="text-fluid-sm font-medium text-slate-900 space-grotesk mb-1">Identify & Submit</h4>
                <p className="text-fluid-sm text-slate-600 space-grotesk">Find companies that need talent.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-orange-600 font-bold text-fluid-sm">2</span>
              </div>
              <div>
                <h4 className="text-fluid-sm font-medium text-slate-900 space-grotesk mb-1">We Connect</h4>
                <p className="text-fluid-sm text-slate-600 space-grotesk">Our team introduces our services.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <CheckCircle className="h-6 w-6 text-green-600 flex-shrink-0 mt-0.5" />
              <div>
                <h4 className="text-fluid-sm font-medium text-slate-900 space-grotesk mb-1">Earn Rewards</h4>
                <p className="text-fluid-sm text-slate-600 space-grotesk">Get paid when they become clients!</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  // Desktop version
  return (
    <Card className={`border border-gray-200 bg-white h-full ${className}`}>
      <CardContent className="p-6 h-full flex flex-col">
        <div className="mb-4">
          <h2 className="text-xl font-bold text-gray-900 mb-2">Client Referral Program</h2>
        </div>
        <div className="flex-1 flex flex-col justify-center">
          <h3 className="text-base font-semibold text-gray-900 mb-4">How It Works</h3>
          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-orange-600 font-bold text-xs">1</span>
              </div>
              <div>
                <h4 className="font-medium text-gray-900 text-sm mb-1">Identify & Submit</h4>
                <p className="text-xs text-gray-600">Refer companies that need talent and submit their details.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <span className="text-orange-600 font-bold text-xs">2</span>
              </div>
              <div>
                <h4 className="font-medium text-gray-900 text-sm mb-1">Connect</h4>
                <p className="text-xs text-gray-600">Our team reaches out and introduces our services.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <CheckCircle className="h-3 w-3 text-green-600" />
              </div>
              <div>
                <h4 className="font-medium text-gray-900 text-sm mb-1">Earn Rewards</h4>
                <p className="text-xs text-gray-600">Get paid when they become clients!</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <Star className="h-3 w-3 text-blue-600" />
              </div>
              <div>
                <h4 className="font-medium text-gray-900 text-sm mb-1">Ideal Clients</h4>
                <p className="text-xs text-gray-600">Companies with 10+ employees actively hiring.</p>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
